import { Component, Inject, Output, ViewChild, ElementRef, EventEmitter, Input, HostListener } from "@angular/core";
import { FormGroup, FormControl, Validator, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA, MatSelect, MatDatepickerInputEvent, MatDialog } from "@angular/material";
import { MiscService } from "../../services/misc.service";
import { MessageService } from '../../services/message.service';
import { MedicineService } from '../../services/medicine.services';
import { BatchService } from '../../services/batch.services';
import { GlobalCfgService } from '../../services/globalcfg.service';
import { EventBusService } from '../../services/event-bus.service';
import * as moment from 'moment';
import { Utils } from 'src/services/utils';
import { DOCUMENT } from '@angular/common';
import { AlertComponent } from '../alert/alert.component';

@Component({
  selector: 'app-edit-batch-dialog',
  templateUrl: './edit-batch-dialog.component.html',
  styleUrls: ['./edit-batch-dialog.component.css']
})
export class EditBatchDialogComponent{

  form: FormGroup;
  medicines: any[];
  applyCountryRestriction: any;
  applyStateRestriction: any;
  google: any;
  map: any;
  date: string;
  batchNo: any;
  center: any;
  isReadOnly: boolean = false;
  mfgDate: any;
  @Input() max: any;
  expiryDate: string;
  drawingManager: any;
  overlays: any[] = [];
  deletedFence: any[] = [];
  selectedControl: string = "drawoff";
  // addRoute: boolean = false;
  // e:any;
  val = 10;
  isFullscreen: boolean = false;
  targetCountries: any;
  batchDetails: any;
  type: string = 'il';    //default is instance level label. other values could be 'cl' - class level, 'bl' - batch level
  selectedShape;
  packageLevels: any[] = [
    { displayName: "Inner Secondary", name: "inner-secondary" },
    { displayName: "Secondary", name: "secondary" },
    { displayName: "Outer Secondary", name: "outer-secondary" }
  ];

  minDate: Date;

  gs1CodesMap = {
    gtinCode: 'gtin',
    piCode: 'packageIndicator',
    batchCode: 'batchNo',
    mfgDtCode: 'mfgDate',
    expDtCode: 'expiryDate',
    snumCode: 'serialNo',
    micrositeCode: 'url'
  }

  productPlaceholder: string;
  labels: any;
  fenceData: any[] = [];
  contextMenu: any;
  overlayEvent: any;
  @Output() selectedfromDateChange = new EventEmitter<Date>();
  isDisplayContextMenu: boolean;
  @Input() rightClickMenuItems: Array<any> = [];
  rightClickMenuPositionX: number;
  rightClickMenuPositionY: number;

  constructor(
    @Inject(DOCUMENT) private _document: any,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<EditBatchDialogComponent>,
    private miscService: MiscService,
    private msgService: MessageService,
    private medicineService: MedicineService,
    private batchService: BatchService,
    private globalCfgService: GlobalCfgService,
    private utils: Utils,
    private busService: EventBusService,
    private dialog: MatDialog,
    // private cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit() {
    // this.batchNo=this.data.batchNo
    this.type = this.data && this.data.type ? this.data.type : 'il';
    this.form = new FormGroup({
      batchNo: new FormControl(), //TODO: We need to have a way to generate as well
      countryCode: new FormControl(),
      region: new FormControl(),
      batchQuantity: new FormControl(),
      gtin: new FormControl(),
      // mfgDate: new FormControl({ disabled: true}),
      mfgDate: new FormControl({ disabled: true, value: '' }, [Validators.required]),
      expiryDate: new FormControl({ disabled: true, value: '' }, [Validators.required]),
      // mfgDate:  [null, Validators.required],
      // expiryDate:new FormControl({ disabled: true}),
      serialNumPrefix: new FormControl(),
      serialNumStartIdx: new FormControl(),
      mfgTemperature: new FormControl(),
      mfgHumidity: new FormControl(),
      gs1CodeList: new FormControl(),
      isNotForSale: new FormControl(),
      isSendCodeInResponse: new FormControl(),
      isTempSensitive: new FormControl(),
      isMoistureSensitive: new FormControl(),
      isLocationTrackingOn: new FormControl(),
      isGeofencingOn: new FormControl(),
      isLightExposureMonitoringOn: new FormControl(),
      isShockMonitoringOn: new FormControl(),
      gtinCode: new FormControl(true),
      piCode: new FormControl(true),
      batchCode: new FormControl(true),
      mfgDtCode: new FormControl(true),
      expDtCode: new FormControl(true),
      snumCode: new FormControl(true),
      micrositeCode: new FormControl(),
      packageLevel: new FormControl(),
      quantity: new FormControl(),
      labelCnt: new FormControl()
    });

    this.labels = this.globalCfgService.getSettingValue('labels');
    this.productPlaceholder = this.labels['medicine'];

    this.google = window["google"];
    this.map = new this.google.maps.Map(
      document.getElementById("geofence_div"),
      {
        center: { lat: 51.476852, lng: -0.0005 },
        zoom: 1,
        mapId: '32c64ca2d80e5193'
      }
    );

    this.contextMenu = document.getElementById('contextMenu');
    // this.map.controls[this.google.maps.ControlPosition.TOP_CENTER].push(this.contextMenu);
    // this.hideContextMenu();

    this.loadTargetCountries();
    this.loadMedicines();

    if (this.data.rec) {
      this.form.disable();
      this.isReadOnly = true;
      this.form.controls.isNotForSale.enable();
      this.form.controls.isLightExposureMonitoringOn.enable();
      this.form.controls.isShockMonitoringOn.enable();
      this.form.controls.isTempSensitive.enable();
      this.form.controls.isMoistureSensitive.enable();
      this.form.controls.isLocationTrackingOn.enable();
      this.form.controls.isGeofencingOn.enable();
      this.form.controls.region.enable();
      this.batchService.getBatchNumber(this.data.rec.batchNo).subscribe((response: any) => {
        this.batchDetails = response;
        this.form.patchValue(this.batchDetails);
        let flags = this.batchDetails.flags;
        this.form.patchValue({
          isLocationTrackingOn: flags.isLocationTrackingOn,
          isGeofencingOn: flags.isLocationTrackingOn === true && this.batchDetails.fences.length > 0,
          isTempSensitive: flags.isTempSensitive,
          isMoistureSensitive: flags.isMoistureSensitive,
          isLightExposureMonitoringOn: flags.isLightExposureMonitoringOn,
          isShockMonitoringOn: flags.isShockMonitoringOn,
          isSendCodeInResponse: flags.isSendCodeInResponse
        });
        //to setup drawing mode when already geofencing is true
        if (this.form.value.isGeofencingOn) {
          const eve = {checked:true};
          this.initMapForFencing(eve);
        } 

        if (this.batchDetails.fences.length > 0) {
          this.showGeoFenceDataOnMapReadOnly(this.batchDetails.fences);
        }
      });
    }
  }

  loadMedicines() {

    var gcp = this.globalCfgService.getGcp();

    this.medicineService.getList(gcp).subscribe(
      (response: any) => {
        this.medicines = response;
      }
    );
  }

  showCountry(e) {
    this.applyCountryRestriction = e.checked;
  }

  showState(e) {
    this.applyStateRestriction = e.checked;
  }

  onSubmit() { }

  getLatLngArr(geoJson) {
    var locations = geoJson.geojson.coordinates
    var latlonArr = [];
    if (geoJson.geojson.type == 'MultiPolygon') {
      locations.forEach(outerArr => {
        outerArr.forEach(innerArr => {
          var lArr = [];
          innerArr.forEach(locArr => {
            lArr.push({
              lat: locArr[1],
              lng: locArr[0]
            });
          });
          latlonArr.push(lArr);
        });
      });
    }
    if (geoJson.geojson.type == 'Polygon') {
      locations.forEach(outerArr => {
        var lArr = [];
        outerArr.forEach(locArr => {
          lArr.push({
            lat: locArr[1],
            lng: locArr[0]
          });
        });
        latlonArr.push(lArr);
      });
    }

    return latlonArr;
  }

  fenceRegion(region, inside) {
    var me = this;
    let regionalFenceOverlay: any = {};
    me.miscService.getGeoJson(region).subscribe((result: any) => {
      if (result["data"].length == 0) {
        me.miscService.geocodeQuery(region).subscribe((result: any) => {
          if (result.length > 0) {

            var data = result[0];
            me.map.setCenter({ lat: data.lat, lng: data.lon });

            me.miscService
              .saveGeoJson({
                queryTxt: region,
                geoJson: JSON.stringify(data)
              })
              .subscribe(
                () => {
                  console.log("GeoJSON saved");
                },
                err => {
                  console.log("Failed to save GeoJSON: ", err);
                }
              );

            var latlonArr = this.getLatLngArr(data);;

            // me.map.data.setStyle({
            //   fillColor: inside ? "#40ec40" : "#ff0000",
            //   strokeColor: inside ? "green" : "red",
            //   strokeWeight: 1
            // });
            let regionCoords = [];
            latlonArr.forEach(item => {
              regionCoords = [...regionCoords, item];
              // me.map.data.add({
              //   geometry: new me.google.maps.Data.Polygon([item])
              // });
            });
            regionalFenceOverlay = new me.google.maps.Polygon({
              id: this.getRandomNewNumberStringBetween(),
              paths: regionCoords,
              fillColor: inside ? "#40ec40" : "#ff0000",
              strokeColor: inside ? "green" : "red",
              strokeWeight: 1
            });
            regionalFenceOverlay.setMap(me.map);
            this.overlays.push(regionalFenceOverlay);
            const overlayObj = {
              id: regionalFenceOverlay.id,
              type: 'region',
              value: [region],
              inside: inside
            }
            this.fenceData.push(overlayObj);
            regionalFenceOverlay.addListener('rightclick',(fObj)=> {
              this.displayContextMenu(fObj, regionalFenceOverlay);
              var selectedOverlay = regionalFenceOverlay;
              selectedOverlay.type = 'region';
              this.setSelection(selectedOverlay);
              fObj.preventDefault();
              fObj.stopPropagation();
            });
          } else {
            me.msgService.showError('Failed to get location detail for ' + region + ' region. Please check your input and try again!');
          }
        });
      } else {
        var geoJson = JSON.parse(result["data"][0].geoJson);
        var latlonArr = this.getLatLngArr(geoJson);

        // me.map.data.setStyle({
        //   fillColor: inside ? "#40ec40" : "#ff0000",
        //   strokeColor: inside ? "green" : "red",
        //   strokeWeight: 1
        // });
        let regionCoords = [];
        latlonArr.forEach(item => {
          regionCoords = [...regionCoords, item];
          // me.map.data.add({
          //   geometry: new me.google.maps.Data.Polygon([item])
          // });
        });
        regionalFenceOverlay = new this.google.maps.Polygon({
          id: this.getRandomNewNumberStringBetween(),
          regionString: region,
          paths: regionCoords,
          fillColor: inside ? "#40ec40" : "#ff0000",
          strokeColor: inside ? "green" : "red",
          strokeWeight: 1
        });
        regionalFenceOverlay.setMap(this.map);
        this.overlays.push(regionalFenceOverlay);
        const overlayObj = {
          id: regionalFenceOverlay.id,
          type: 'region',
          value: [region],
          inside: inside
        }
        this.fenceData.push(overlayObj);
        regionalFenceOverlay.addListener('rightclick',(fObj)=> {
          this.displayContextMenu(fObj, regionalFenceOverlay);
          var selectedOverlay = regionalFenceOverlay;
          selectedOverlay.type = 'region';
          this.setSelection(selectedOverlay);
          fObj.preventDefault();
          fObj.stopPropagation();
        });
      }

      // var obj = this.utils.getObject('type', 'region', this.fenceData);
      // if (obj) {
      //   obj.value.push(region);
      // } else {
        // console.log(regionalFenceOverlay);
        
      // }
    }
    );
  }

  initMapForFencing(e) {
    var me = this;

    if (e.checked && this.drawingManager) {
      this.drawingManager.setMap(this.map);
    }

    if (e.checked && !this.drawingManager) {
      me.drawingManager = new me.google.maps.drawing.DrawingManager({
        drawingMode: null,
        drawingControl: false,
        drawingControlOptions: {
          position: me.google.maps.ControlPosition.TOP_CENTER,
          drawingModes: ["circle", "polygon", "polyline", "rectangle"],

        },
        circleOptions: {
          id: this.getRandomNewNumberStringBetween(),
          fillColor: "#40ec40",
          strokeColor: "green",
          strokeWeight: 1,
          radius: 10000,
          center: this.center,
          clickable: true,
          editable: true
        },
        polygonOptions: {
          id: this.getRandomNewNumberStringBetween(),
          fillColor: "#40ec40",
          strokeColor: "green",
          strokeWeight: 1,
          clickable: true,
          editable: true
        },
        polylineOptions: {
          id: this.getRandomNewNumberStringBetween(),
          fillColor: "#40ec40",
          strokeColor: "green",
          clickable: true,
          editable: true
        },
        rectangleOptions: {
          id: this.getRandomNewNumberStringBetween(),
          fillColor: "#40ec40",
          strokeColor: "green",
          strokeWeight: 1,
          clickable: true,
          editable: true
        }
      });
      me.drawingManager.setMap(me.map);
      me.drawingManager.addListener("overlaycomplete", function (e) {
        e.overlay.setEditable(true);
        me.overlays.push(e.overlay);

        var overlayEvent = new me.google.maps.OverlayView();
        overlayEvent.setMap(me.map);
 
        e.inside = true;
        me.pushToFenced(e);
        if (e.type === 'circle') {
          me.setCircleOverlayListeners(e.overlay);
        } else if (e.type === 'rectangle') {
          me.setRectOverlayListeners(e.overlay);
        } else if (e.type === 'polygon') {
          me.setPolygonListeners(e.overlay);
        } else if (e.type === 'polyline') {
          me.setPolyLineListeners(e.overlay);
        } else {
          me.google.maps.event.addListener(e.overlay,'rightclick', function(rcObj) {
            me.displayContextMenu(rcObj, e.overlay);
            var selectedOverlay = e.overlay;
            selectedOverlay.type = e.type;
            me.setSelection(selectedOverlay);
            rcObj.preventDefault();
            rcObj.stopPropagation();
          });
        }

        if (e.type != me.google.maps.drawing.OverlayType.MARKER) {
          // Switch back to non-drawing mode after drawing a shape.
          me.drawingManager.setDrawingMode(null);
          // Add an event listener that selects the newly-drawn shape when the user
          // mouses down on it.
          var newShape = e.overlay;
          newShape.type = e.type;
          me.google.maps.event.addListener(newShape);
          me.setSelection(newShape);
        }
        me.setSelection(newShape);
          
      });
      me.drawingManager.addListener("click", function (e) {
        console.log("click: ", e);
      });


    }
    // function initialize(longitude, latitude) {

    // }
    // this.google.maps.event.addListener(this.drawingManager, 'circlecomplete', function (circle) {
    //   var radius = circle.getRadius();
    // });
    // this.google.maps.event.addListener(this.drawingManager, 'overlaycomplete', function (event) {
    //   if (event.type == 'circle') {
    //     var radius = event.overlay.getRadius();
    //   }
    // });
    // if (!e.checked && this.drawingManager) {
    //   this.drawingManager.setMap(null);
    // }
    
  }

  displayContextMenu(event, overlayObj) {
    // console.log(overlayObj, this.fenceData);
    const toCheckObj = this.fenceData.find(obj => {
      return obj.id === overlayObj.id;
    });
    this.isDisplayContextMenu = true;
    this.rightClickMenuItems = [
      {
        menuText:'gps_fixed',
        menuEvent: 'Handle',
        tip: toCheckObj.inside ? 'Mark fence as outside' : 'Mark fence as inside'
      },
      {
        menuText:'delete',
        menuEvent: 'refactor',
        tip:'Delete fence'
      }
    ];    
    this.rightClickMenuPositionX = event.domEvent.clientX;
    this.rightClickMenuPositionY = event.domEvent.clientY;
  }

  getRightClickMenuStyle() {
    return {
      position: 'fixed',
      left: `${this.rightClickMenuPositionX}px`,
      top: `${this.rightClickMenuPositionY}px`
    }
  }

  handleMenuItemClick(event) {    
    switch (event.data) {
      case this.rightClickMenuItems[0].menuEvent:
        this.markFenceInsideOrOutside(event);
        break;
      case this.rightClickMenuItems[1].menuEvent:
        this.deleteSelectedFence(event, 'delete');
        break;
    }
  }

  @HostListener('document:click')
  documentClick(): void {
    this.isDisplayContextMenu = false;
  }

  // showContextMenu(event) {
  //   // this.contextMenu.css("display", "block");
  //   this.contextMenu.css({
  //     left: event.pixel.x,
  //     top: event.pixel.y
  //   })
  //       //  $('#menu').show();
  //       //  $('#menu').css("left", event.pixel.x);
  //       //  $('#menu').css("top", event.pixel.y);
  // }

  // hideContextMenu(e?) {
  //   // this.contextMenu.css("display", "none");
  //   if (e == "edit") {
  //     this.overlayEvent.overlay.setEditable(true);
  //   }
  //   if (e == "delete") {
  //     this.overlayEvent.overlay.setMap(null)
  //   }
  //   if (e == "insideOut") {
  //     this.overlayEvent.inside = false;
  //     this.pushToFenced(this.overlayEvent);
  //   }
  // }

  pushToFenced(obj) {
    switch (obj.type) {
      case 'circle':
        this.fenceData.push({
          type: 'circle',
          value: {
            center: obj.overlay.center.toJSON(),
            radius: obj.overlay.radius
          },
          inside: obj.inside,
          id: obj.overlay.id,
        });
        break;
      case 'rectangle':
        this.fenceData.push({
          type: 'rectangle',
          value: {
            center: this.map.getCenter(),
            bounds: obj.overlay.bounds.toJSON()
          },
          inside: obj.inside,
          id: obj.overlay.id,
        });
        break;
      case 'polyline':
        this.fenceData.push({
          type: 'polyline',
          value: {
            path: obj.overlay.getPath().getArray().toString()
          },
          inside: obj.inside,
          id: obj.overlay.id,
        });
        break;
      case 'polygon':
        this.fenceData.push({
          type: 'polygon',
          value: {
            path: obj.overlay.getPath().getArray().toString()
          },
          inside: obj.inside,
          id: obj.overlay.id,
        });
        break;
      default:
        console.log('Unsupported fence type: ', obj.type);
    }
  }

  turnOffDrawing() {
    this.selectedControl = "drawoff";
    this.drawingManager.setDrawingMode(null);
    this.overlays.forEach(o => o.setEditable(false));
  }

  turnOnDrawing() {
    this.selectedControl = "edit";
    this.drawingManager.setDrawingMode(null);
    this.overlays.forEach(o => o.setEditable(true));
  }

  // deleteDrawing(e) {
  //   console.log("delete event:", e);
  //   this.selectedControl = "delete";
  //   this.drawingManager.setDrawingMode(null);
  //   this.overlays.forEach(o => {
  //     o.setMap(null);
  //   });
  // }

  addCircle() {
    this.selectedControl = "circle";
    this.drawingManager.setDrawingMode(
      this.google.maps.drawing.OverlayType.CIRCLE

    );
  }

  addRectangle() {
    this.selectedControl = "rect";
    this.drawingManager.setDrawingMode(
      this.google.maps.drawing.OverlayType.RECTANGLE
    );
  }

  addPolyline() {
    this.selectedControl = "polyline";
    this.drawingManager.setDrawingMode(
      this.google.maps.drawing.OverlayType.POLYLINE
    );
  }

  addPolygon() {
    this.selectedControl = "polygon";
    this.drawingManager.setDrawingMode(
      this.google.maps.drawing.OverlayType.POLYGON
    );
  }

  // addRoadMap() {
  //   this.selectedControl = "roadMap";
  //   this.addRoute = true;
  //   const input = document.getElementById("pac-input1") as HTMLInputElement;
  //   const searchBox = new this.google.maps.places.SearchBox(input);
  //   this.map.controls[this.google.maps.ControlPosition.TOP_LEFT].push(input);

  //   // this.map.addListener("bounds_changed", () => {
  //   //   searchBox.setBounds(this.map.getBounds() as this.google.maps.LatLngBounds);
  //   // });
  // }

  showFullscreen() {
    this.isFullscreen = true;
    var el = document.getElementById("geofence-map-ct");
    if (el.requestFullscreen) {
      el.requestFullscreen();
    }
  }

  exitFullscreen() {
    this.isFullscreen = false;

    if (document.exitFullscreen) {
      document.exitFullscreen();
    }
  }

  // adding new regional fence from ui
  findAndShowRegion(region) {
    // hence passing inside as true (second parameter)
    region = region.toLowerCase();
    const resulted = this.fenceData.findIndex(reg => reg.value[0] === region);
    if (resulted == -1){
      this.fenceRegion(region, true);
    }
    else {
      const dialogRef = this.dialog.open(AlertComponent, {
        width: "600px",
        data: {
              title: 'Region exists',
              note: 'Region already added'
              }
      });
    }
  }

  loadTargetCountries() {
    this.miscService.gteTargetCountries().subscribe(
      (response: any) => {
        this.targetCountries = response['data'];
      }
    );
  }

  addBatch(values) {
    let gs1CodeList = [];
    if (values.gtinCode) gs1CodeList.push(this.gs1CodesMap.gtinCode);
    if (values.batchCode) gs1CodeList.push(this.gs1CodesMap.batchCode);
    if (values.piCode) gs1CodeList.push(this.gs1CodesMap.piCode);
    if (values.mfgDtCode) gs1CodeList.push(this.gs1CodesMap.mfgDtCode);
    if (values.expDtCode) gs1CodeList.push(this.gs1CodesMap.expDtCode);
    if (values.snumCode) gs1CodeList.push(this.gs1CodesMap.snumCode);
    if (values.micrositeCode) gs1CodeList.push(this.gs1CodesMap.micrositeCode);

    if (this.type == 'sl') {
      let record = {
        batchNo: values.batchNo,
        gtin: values.gtin,
        countryCode: values.countryCode,
        packageLevel: values.packageLevel,
        packageType: "homogeneous",
        gs1ApplicationIdentifiers: gs1CodeList,
        quantity: values.quantity,
        batchQuantity: values.batchQuantity,
        labelCnt: values.labelCnt,
        mfgDate: moment(this.mfgDate).utc().format(),
        expiryDate: moment(this.expiryDate).add(moment.duration('23:59')).utc().format(),
        eventTimeZoneOffset: this.utils.getTimeZoneFromDateString(moment(this.mfgDate).format()),
        flags: {
          geofencing: true,
          isTempSensitive: true,
          isMoistureSensitive: true,
          isLocationTrackingOn: true,
          isLightExposureMonitoringOn: false,
          isShockMonitoringOn: false
        }
      }

      this.batchService.createNonAggPackage(record).subscribe(
        (response: any) => {
          if (response.status) {
            this.dialogRef.close(response);
            this.msgService.showSuccess(this.msgService.labelsEmail);
          } else {
            this.msgService.showError(this.msgService.labelsCreateFail);
          }
        }
      );
    } else {
      // remove id property in fenceData obj for new fence overlay
      this.fenceData = this.removeIdFenceData(this.fenceData);

      let rec = {
        batchNo: values.batchNo,
        gtin: values.gtin,
        countryCode: values.countryCode,
        serialNumPrefix: values.serialNumPrefix || "",
        serialNumStartIdx: values.serialNumStartIdx || "",
        mfgDate: moment(this.mfgDate).utc().format(),
        expiryDate: moment(this.expiryDate).add(moment.duration('23:59')).utc().format(),
        eventTimeZoneOffset: this.utils.getTimeZoneFromDateString(moment(this.mfgDate).format()),
        batchQuantity: values.batchQuantity,
        mfgTemperature: values.mfgTemperature || "",
        mfgHumidity: values.mfgHumidity || "",
        isNotForSale: values.isNotForSale || false,
        gs1ApplicationIdentifiers: gs1CodeList,
        flags: {
          isSendCodeInResponse: values.isSendCodeInResponse || false,
          isTempSensitive: values.isTempSensitive || false,
          isMoistureSensitive: values.isMoistureSensitive || false,
          isLocationTrackingOn: values.isLocationTrackingOn || false,
          isGeofencingOn: {
            type: 'region',  //region/polygon/polyline/circle/rectangle
            value: 'India' //'India'/[lat,lng]
          },
          isLightExposureMonitoringOn: values.isLightExposureMonitoringOn || false,
          isShockMonitoringOn: values.isShockMonitoringOn || false
        },
        gcp: this.globalCfgService.getGcp(),
        fence: this.fenceData,
        serializationType: this.type,
        deletedFence: this.deletedFence 
      };
      console.log(rec,'updated record');

      this.batchService.updateBatch(rec).subscribe(
        (response: any) => {
          if (response.status) {
            this.dialogRef.close(response);
            this.msgService.showSuccess(this.msgService.batchUpdate);
          } else {
            this.msgService.showError(this.msgService.batchUpdateFail);
          }
        }
      );
    }
  }

  cancel() {
    this.dialogRef.close();
  }

  setMfgDate(e) {
    this.mfgDate = e;
    // console.log('e',e);
    // console.log(typeof $event);
  }

  setExpiryDate(e) {
    this.expiryDate = e;

    // console.log( $event instanceof Date);
    // console.log(e)
    // console.log(this.expiryDate)
  }

  showGeoFenceDataOnMapReadOnly(fences) {
    // console.log(fences);
    fences.forEach(fenceObj => {
      if (fenceObj.type === 'region') {
        let regionObj = {regionValue: fenceObj.value, inside: fenceObj.inside};
        regionObj.regionValue = regionObj.regionValue.replace("[", "");
        regionObj.regionValue = regionObj.regionValue.replace("]", "");
        this.fetchAndShowRegionFence(regionObj, fenceObj.id, false);
      } else if (fenceObj.type === 'rectangle') {
        const fenceObjJSON = JSON.stringify(fenceObj);
        this.showRectangleFence(fenceObjJSON, fenceObj.id, false);
      } else if (fenceObj.type === 'circle') {
        const fenceObjJSON = JSON.stringify(fenceObj);
        this.showCircleFence(fenceObjJSON, fenceObj.id, false);
      } else if (fenceObj.type === 'polyline') {
        const fenceObjJSON = JSON.stringify(fenceObj);
        this.showPolyLineFence(fenceObjJSON, fenceObj.id, false);
      } else if (fenceObj.type === 'polygon') {
        const fenceObjJSON = JSON.stringify(fenceObj);
        this.showPolygonFence(fenceObjJSON, fenceObj.id, false);
      }
    });
  }

  fetchAndShowRegionFence(regionObj, id, reDraw) {
    if (reDraw === true) {
      regionObj = JSON.parse(regionObj);
    } else {
      regionObj.regionValue = JSON.parse(regionObj.regionValue);
    }
    regionObj.regionValue = regionObj.regionValue.toLowerCase();
    let regionalFenceOverlay: any = {};
    this.miscService.geocodeQuery(regionObj.regionValue).subscribe((result: any) => {
      if (result.length > 0) {

        // var data = result[0];
        // this.map.setCenter({ lat: data.lat, lng: data.lon });

        var latlonArr = this.getLatLngArr(result[0]);;

        // this.map.data.setStyle({
        //   fillColor: regionObj.inside ? "#40ec40" : "#ff0000",
        //   strokeColor: regionObj.inside ? "green" : "red",
        //   strokeWeight: 1
        // });
        let regionCoords = [];
        latlonArr.forEach(item => {
          regionCoords = [...regionCoords, item];
          // this.map.data.add({
          //   geometry: new this.google.maps.Data.Polygon([item])
          // });
        });

        regionalFenceOverlay = new this.google.maps.Polygon({
          id: id,
          regionString: regionObj.regionValue,
          paths: regionCoords,
          fillColor: regionObj.inside ? "#40ec40" : "#ff0000",
          strokeColor: regionObj.inside ? "green" : "red",
          strokeWeight: 1
        });
        regionalFenceOverlay.setMap(this.map);
        // console.log(regionalFenceOverlay);
        this.overlays.push(regionalFenceOverlay);
        const overlayObj = {
          id: id,
          type: 'region',
          value: [regionObj.regionValue],
          inside: regionObj.inside
        }
        this.fenceData.push(overlayObj);
        regionalFenceOverlay.addListener('rightclick',(fObj)=> {
          this.displayContextMenu(fObj, regionalFenceOverlay);
          var selectedOverlay = regionalFenceOverlay;
          selectedOverlay.type = 'region';
          this.setSelection(selectedOverlay);
          console.log(fObj.domEvent.defaultPrevented);
          fObj.domEvent.preventDefault();
          console.log(fObj.domEvent, fObj.domEvent.defaultPrevented);
          // fObj.preventDefault();
          // fObj.stopPropagation();
        });
      }
    });
  }

  showRectangleFence(data, id, reDraw) {
    let dataObj: any = {};
    if (JSON.parse(data).value) {
      dataObj = JSON.parse(JSON.parse(data).value);
      dataObj.inside = JSON.parse(data).inside;
    } else {
      dataObj = JSON.parse(data);
    }
    // console.log(dataObj, data, 'rectangle');
    const map = this.map;
    const rectangle = new this.google.maps.Rectangle({
      id: id,
      fillColor: dataObj.inside ? "#40ec40" : "#ff0000",
      strokeColor: dataObj.inside ? "green" : "red",
      strokeWeight: 1,
      map,
      value: {
        center: {
          lat: dataObj.center.lat,
          lng: dataObj.center.lng
        }
      },
      bounds: {
        north: dataObj.bounds.north,
        south: dataObj.bounds.south,
        east: dataObj.bounds.east,
        west: dataObj.bounds.west,
      },
    });
    if (reDraw) {
      rectangle.setEditable(true);
    }
    this.overlays.push(rectangle);
    const overlayObj = {
      id: id,
      type: 'rectangle',
      overlay: rectangle,
      inside: dataObj.inside
    }
    this.pushToFenced(overlayObj);
    this.setRectOverlayListeners(rectangle);
  }

  setRectOverlayListeners(rectangle) {
    rectangle.addListener('rightclick',(fObj)=> {
      this.displayContextMenu(fObj, rectangle);
      var selectedOverlay = rectangle;
      selectedOverlay.type = 'rectangle';
      this.setSelection(selectedOverlay);
      fObj.preventDefault();
      fObj.stopPropagation();
    });
    // Add an event listener on rectangle overlay for edit.
    rectangle.addListener("bounds_changed", () => {
      const updatedFenceDataIdx = this.fenceData.findIndex(o => {
        return o.id === rectangle.id;
      });
      if (updatedFenceDataIdx > -1) {
        this.fenceData[updatedFenceDataIdx].value.bounds = rectangle.bounds.toJSON();
      }
    });
  }

  showCircleFence(data, id, reDraw) {
    let dataObj: any = {};
    if (JSON.parse(data).value) {
      dataObj = JSON.parse(JSON.parse(data).value);
      dataObj.inside = JSON.parse(data).inside;
    } else {
      dataObj = JSON.parse(data);
    }

    // console.log(dataObj, data, 'circle');
    const map = this.map;
    const circle = new this.google.maps.Circle({
      id: id,
      fillColor: dataObj.inside ? "#40ec40" : "#ff0000",
      strokeColor: dataObj.inside ? "green" : "red",
      strokeWeight: 1,
      strokeOpacity: 0.8,
      fillOpacity: 0.35,
      map,
      center: {
        lat: dataObj.center.lat,
        lng: dataObj.center.lng,
      },
      radius: dataObj.radius
    });
    if (reDraw) {
      circle.setEditable(true);
    }
    this.overlays.push(circle);
    const overlayObj = {
      id: id,
      type: 'circle',
      overlay: circle,
      inside: dataObj.inside
    }
    this.pushToFenced(overlayObj);
    this.setCircleOverlayListeners(circle);
  }

  setCircleOverlayListeners(circle) {
    circle.addListener('rightclick',(fObj)=> {
      this.displayContextMenu(fObj, circle);
      let selectedOverlay = circle;
      selectedOverlay.type = 'circle';
      this.setSelection(selectedOverlay);
      fObj.preventDefault();
      fObj.stopPropagation();
    });
    // Add an event listener on the circle for edit.
    // console.log('existing radius:', circle.radius);
    // console.log('existing center:', circle.center.lat(), circle.center.lng());
    circle.addListener("radius_changed", () => {
      // console.log('radius_changed', circle, circle.radius, circle.center.lat(), circle.center.lng());
      const updatedFenceDataIdx = this.fenceData.findIndex(o => {
        return o.id === circle.id;
      });
      if (updatedFenceDataIdx > -1) {
        this.fenceData[updatedFenceDataIdx].value.radius = circle.radius;
      }
    });
    circle.addListener("center_changed", () => {
      // console.log('center_changed', circle, circle.radius, circle.center.lat(), circle.center.lng());
      const updatedFenceDataIdx = this.fenceData.findIndex(o => {
        return o.id === circle.id;
      });
      if (updatedFenceDataIdx > -1) {
        this.fenceData[updatedFenceDataIdx].value.center = circle.center.toJSON();
      }
    });
  }

  showPolyLineFence(data, id, reDraw) {
    let dataObj: any = {};
    if (JSON.parse(data).value) {
      dataObj = JSON.parse(JSON.parse(data).value);
      dataObj.inside = JSON.parse(data).inside;
    } else {
      dataObj = JSON.parse(data);
    }

    const map = this.map;
    let newDataObj = dataObj.path.split("),(");
    for (var i = 0; i < newDataObj.length; i++) {
      let vals = newDataObj[i].split(', ');
      let latVal: string, lngVal: string;
      if (i === 0) {
        latVal = vals[0].replace('(', '');
        lngVal = vals[1];
        newDataObj[i] = { lat: parseFloat(latVal), lng: parseFloat(lngVal) };
      } else if (i === newDataObj.length - 1) {
        latVal = vals[0];
        lngVal = vals[1].replace(')', '');
        newDataObj[i] = { lat: parseFloat(latVal), lng: parseFloat(lngVal) };
      } else {
        newDataObj[i] = { lat: parseFloat(vals[0]), lng: parseFloat(vals[1]) };
      }
    }
    const polyLineOverlay = new this.google.maps.Polyline({
      id: id,
      path: newDataObj,
      geodesic: true,
      fillColor: dataObj.inside ? "#40ec40" : "#ff0000",
      strokeColor: dataObj.inside ? "green" : "red",
      strokeWeight: 1
    });
    polyLineOverlay.setMap(map);
    if (reDraw) {
      polyLineOverlay.setEditable(true);
    }
    this.overlays.push(polyLineOverlay);
    const overlayObj = {
      id: id,
      type: 'polyline',
      overlay: polyLineOverlay,
      inside: dataObj.inside
    }
    this.pushToFenced(overlayObj);
    this.setPolyLineListeners(polyLineOverlay);
  }

  setPolyLineListeners(polyLineOverlay) {
    polyLineOverlay.addListener('rightclick',(fObj)=> {
      this.displayContextMenu(fObj, polyLineOverlay);
      let selectedOverlay = polyLineOverlay;
      selectedOverlay.type = 'polygon';
      this.setSelection(selectedOverlay);
      fObj.preventDefault();
      fObj.stopPropagation();
    });
    // Add an event listener on the polygon for edit.
    polyLineOverlay.getPath().addListener("set_at", () => {
      // console.log(polyLineOverlay);
      const updatedFenceDataIdx = this.fenceData.findIndex(o => {
        return o.id === polyLineOverlay.id;
      });
      if (updatedFenceDataIdx > -1) {
        this.fenceData[updatedFenceDataIdx].value.path = polyLineOverlay.getPath().getArray().toString();
      }
    });
  }

  showPolygonFence(data, id, reDraw) {
    let dataObj: any = {};
    if (JSON.parse(data).value) {
      dataObj = JSON.parse(JSON.parse(data).value);
      dataObj.inside = JSON.parse(data).inside;
    } else {
      dataObj = JSON.parse(data);
    }
    
    // console.log(dataObj, data, 'polygon');
    const map = this.map;
    let newDataObj = dataObj.path.split("),(");
    for (var i = 0; i < newDataObj.length; i++) {
      let vals = newDataObj[i].split(', ');
      let latVal: string, lngVal: string;
      if (i === 0) {
        latVal = vals[0].replace('(', '');
        lngVal = vals[1];
        newDataObj[i] = { lat: parseFloat(latVal), lng: parseFloat(lngVal) };
      } else if (i === newDataObj.length - 1) {
        latVal = vals[0];
        lngVal = vals[1].replace(')', '');
        newDataObj[i] = { lat: parseFloat(latVal), lng: parseFloat(lngVal) };
      } else {
        newDataObj[i] = { lat: parseFloat(vals[0]), lng: parseFloat(vals[1]) };
      }
    }
    const polygonOverlay = new this.google.maps.Polygon({
      id: id,
      path: newDataObj,
      geodesic: true,
      fillColor: dataObj.inside ? "#40ec40" : "#ff0000",
      strokeColor: dataObj.inside ? "green" : "red",
      strokeWeight: 1
    });
    polygonOverlay.setMap(map);
    if (reDraw) {
      polygonOverlay.setEditable(true);
    }
    this.overlays.push(polygonOverlay);
    const overlayObj = {
      id: id,
      type: 'polygon',
      overlay: polygonOverlay,
      inside: dataObj.inside
    }
    this.pushToFenced(overlayObj);
    this.setPolygonListeners(polygonOverlay);
  }

  setPolygonListeners(polygonOverlay) {
    polygonOverlay.addListener('rightclick',(fObj)=> {
      this.displayContextMenu(fObj, polygonOverlay);
      let selectedOverlay = polygonOverlay;
      selectedOverlay.type = 'polygon';
      this.setSelection(selectedOverlay);
      fObj.preventDefault();
      fObj.stopPropagation();
    });
    // Add an event listener on the polygon for edit.
    polygonOverlay.getPath().addListener("set_at", () => {
      // console.log(polygonOverlay);
      const updatedFenceDataIdx = this.fenceData.findIndex(o => {
        return o.id === polygonOverlay.id;
      });
      if (updatedFenceDataIdx > -1) {
        this.fenceData[updatedFenceDataIdx].value.path = polygonOverlay.getPath().getArray().toString();
      }
    });
  }

  clearSelection() {
    if (this.selectedShape) {
      this.selectedShape.setEditable(false);
      this.selectedShape = null;
    }
  }
  
  setSelection(shape) {
    this.clearSelection();
    this.selectedShape = shape;
    if (this.selectedShape.type !== 'region') {  
      shape.setEditable(true);
    }
  }

  markFenceInsideOrOutside(e){
    // console.log(e);
    if (this.selectedShape.type === 'circle') {
      const toredrawShape = Object.assign({}, this.selectedShape);
      // removing existing overlay (map ui part)
      this.deleteSelectedFence(this.selectedShape, 'edit');
      let deletedIdx = this.overlays.findIndex(o => {
        return o.id === toredrawShape.id;
      });
      if (deletedIdx > -1) {
        this.overlays.splice(deletedIdx, 1);
      }
      // check toReDraw is inside or outside & 
      // removing existing overlay (to save data part)
      let deletedFenceDataIdx = this.fenceData.findIndex(o => {
        return o.id === toredrawShape.id;
      });
      if (deletedFenceDataIdx > -1) {
        toredrawShape.inside = this.fenceData[deletedFenceDataIdx].inside;
        this.fenceData.splice(deletedFenceDataIdx, 1);
      }
      // draw new overlay with change as inside or outside
      let redrawObj: any = {
        center: {lat: toredrawShape.center.lat(), lng: toredrawShape.center.lng()},
        radius: toredrawShape.radius,
        inside: !toredrawShape.inside
      };
      redrawObj = JSON.stringify(redrawObj);
      if (typeof toredrawShape.id === 'string' && toredrawShape.id.includes('-new')) {
        this.showCircleFence(redrawObj, this.getRandomNewNumberStringBetween(), true);
      } else {
        this.showCircleFence(redrawObj, toredrawShape.id, true);
      }
    }

    if (this.selectedShape.type === 'rectangle') {
      // console.log(this.selectedShape.bounds);
      const toredrawShape = Object.assign({}, this.selectedShape);
      // removing existing overlay (map ui part)
      this.deleteSelectedFence(this.selectedShape, 'edit');
      let deletedIdx = this.overlays.findIndex(o => {
        return o.id === toredrawShape.id;
      });
      if (deletedIdx > -1) {
        this.overlays.splice(deletedIdx, 1);
      }
      // check toReDraw is inside or outside & 
      // removing existing overlay (to save data part)
      let deletedFenceDataIdx = this.fenceData.findIndex(o => {
        return o.id === toredrawShape.id;
      });
      if (deletedFenceDataIdx > -1) {
        toredrawShape.inside = this.fenceData[deletedFenceDataIdx].inside;
        this.fenceData.splice(deletedFenceDataIdx, 1);
      }
      // draw new overlay with change as inside or outside
      let redrawObj: any = {
        center:{ 
          lat: toredrawShape.map.center.lat(),
          lng: toredrawShape.map.center.lng()
        },
        bounds: toredrawShape.bounds.toJSON(),
        inside: !toredrawShape.inside
      };
      redrawObj = JSON.stringify(redrawObj);
      if (typeof toredrawShape.id === 'string' && toredrawShape.id.includes('-new')) {
        this.showRectangleFence(redrawObj, this.getRandomNewNumberStringBetween(), true);
      } else {
        this.showRectangleFence(redrawObj, toredrawShape.id, true);
      }
    }

    if (this.selectedShape.type === 'region') {
      const toredrawShape = Object.assign({}, this.selectedShape);
      // removing existing overlay (map ui part)
      this.deleteSelectedFence(this.selectedShape, 'edit');
      let deletedIdx = this.overlays.findIndex(o => {
        return o.id === toredrawShape.id;
      });
      if (deletedIdx > -1) {
        this.overlays.splice(deletedIdx, 1);
      }
      // check toReDraw is inside or outside & 
      // removing existing overlay (to save data part)
      let deletedFenceDataIdx = this.fenceData.findIndex(o => {
        return o.id === toredrawShape.id;
      });
      if (deletedFenceDataIdx > -1) {
        toredrawShape.inside = this.fenceData[deletedFenceDataIdx].inside;
        this.fenceData.splice(deletedFenceDataIdx, 1);
      }
      // draw new overlay with change as inside or outside
      console.log(toredrawShape);
      let redrawObj: any = {
        regionValue: toredrawShape.regionString,
        inside: !toredrawShape.inside
      };
      redrawObj = JSON.stringify(redrawObj);
      if (typeof toredrawShape.id === 'string' && toredrawShape.id.includes('-new')) {
        this.fetchAndShowRegionFence(redrawObj, this.getRandomNewNumberStringBetween(), true);
      } else {
        this.fetchAndShowRegionFence(redrawObj, toredrawShape.id, true);
      }
    }

    if (this.selectedShape.type === 'polygon') {
      const toredrawShape = Object.assign({}, this.selectedShape);
      // removing existing overlay (map ui part)
      this.deleteSelectedFence(this.selectedShape, 'edit');
      let deletedIdx = this.overlays.findIndex(o => {
        return o.id === toredrawShape.id;
      });
      if (deletedIdx > -1) {
        this.overlays.splice(deletedIdx, 1);
      }
      // check toReDraw is inside or outside & 
      // removing existing overlay (to save data part)
      let deletedFenceDataIdx = this.fenceData.findIndex(o => {
        return o.id === toredrawShape.id;
      });
      if (deletedFenceDataIdx > -1) {
        toredrawShape.inside = this.fenceData[deletedFenceDataIdx].inside;
        toredrawShape.value = this.fenceData[deletedFenceDataIdx].value;
        this.fenceData.splice(deletedFenceDataIdx, 1);
      }
      // draw new overlay with change as inside or outside
      let redrawObj: any = {
        path: toredrawShape.value.path,
        inside: !toredrawShape.inside,
      };
   
      redrawObj = JSON.stringify(redrawObj);
      if (typeof toredrawShape.id === 'string' && toredrawShape.id.includes('-new')) {
        this.showPolygonFence(redrawObj, this.getRandomNewNumberStringBetween(), true);
      } else {
        this.showPolygonFence(redrawObj, toredrawShape.id, true);
      }
    }

    if (this.selectedShape.type === 'polyline') {
      const toredrawShape = Object.assign({}, this.selectedShape);
      // removing existing overlay (map ui part)
      this.deleteSelectedFence(this.selectedShape, 'edit');
      let deletedIdx = this.overlays.findIndex(o => {
        return o.id === toredrawShape.id;
      });
      if (deletedIdx > -1) {
        this.overlays.splice(deletedIdx, 1);
      }
      // check toReDraw is inside or outside & 
      // removing existing overlay (to save data part)
      let deletedFenceDataIdx = this.fenceData.findIndex(o => {
        return o.id === toredrawShape.id;
      });
      if (deletedFenceDataIdx > -1) {
        toredrawShape.inside = this.fenceData[deletedFenceDataIdx].inside;
        toredrawShape.value = this.fenceData[deletedFenceDataIdx].value;
        this.fenceData.splice(deletedFenceDataIdx, 1);
      }
      // draw new overlay with change as inside or outside
      let redrawObj: any = {
        path: toredrawShape.value.path,
        inside: !toredrawShape.inside,
      };
   
      redrawObj = JSON.stringify(redrawObj);
      if (typeof toredrawShape.id === 'string' && toredrawShape.id.includes('-new')) {
        this.showPolyLineFence(redrawObj, this.getRandomNewNumberStringBetween(), true);
      } else {
        this.showPolyLineFence(redrawObj, toredrawShape.id, true);
      }
    }
  }
  
  deleteSelectedFence(e, actionType) {
    this.selectedControl = "delete";
    this.drawingManager.setDrawingMode(null);
   
    if (this.selectedShape) {
      // console.log(this.selectedShape.id);
      if (
        actionType === 'delete' &&
        this.selectedShape.id
      ) {
        if (typeof this.selectedShape.id !== 'string') {
          this.deletedFence.push(this.selectedShape.id);
        }
        let deletedFenceDataIdx = this.fenceData.findIndex(o => {
          return o.id === this.selectedShape.id;
        });
        if (deletedFenceDataIdx > -1) {
          this.fenceData.splice(deletedFenceDataIdx, 1);
        }
      }
      this.selectedShape.setMap(null);
    }
  }
  
  deleteAllFences() {
    this.selectedControl = "deleteAll";
     this.overlays.forEach(o => {
      o.setMap(null);
    });
    // set to delete fence ids
    this.fenceData.forEach(fenceObj => {
      if (typeof fenceObj.id !== 'string') {
        this.deletedFence.push(fenceObj.id);
      }
    });
    // clear to save obj: fenceData
    this.fenceData = [];
  }
 
  // unique id setup to identify fence obj (overlays) when change is applied to them
  getRandomNewNumberStringBetween() {
    const min = 100, max = 150;
    const numPart = Math.floor(Math.random() * (max - min + 1) + min);
    return numPart + '-new';
  }

  removeIdFenceData(fenceData) {
    fenceData.forEach(fence => {
      if (fence.id && typeof fence.id === 'string' && fence.id.includes('-new')) {
        delete fence.id;
      }
    });
    return fenceData;
  }
}
